import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { addAndApplyFilter } from '../../actions/filterActions';
import { isValidBoundedDate } from '../../utils/dateUtils';
import { tradeDoublePointsPromo } from '../../constants/tradePromoConstants';
import { getFilterValueByUrlLabel } from '../SbSharedRefineMenu/sbSharedRefineMenuHelpers';

import styles from './SbRespTradePromoDoublePoints.scss';

export function SbRespTradePromoDoublePointsComponent({ searchBrowse, onLinkClick }) {
    const appliedFilters = searchBrowse.appliedFilters || [];
    const validDate = isValidBoundedDate({ endDate: tradeDoublePointsPromo.END_DATE });
    const isLightingFiltered = !!getFilterValueByUrlLabel(
        appliedFilters,
        tradeDoublePointsPromo.TARGET_CATEGORY.LEVEL,
        tradeDoublePointsPromo.TARGET_CATEGORY.NAME
    );
    const isNewAndCustomFiltered = !!getFilterValueByUrlLabel(
        appliedFilters,
        tradeDoublePointsPromo.TARGET_FILTER.NAME,
        tradeDoublePointsPromo.TARGET_FILTER.ATTRIBUTE
    );

    const doubleCopyEl = (
        <FormattedMessage id="SbRespTradePromoDoublePoints.doublePoints" defaultMessage="2x" />
    );

    if (!isLightingFiltered || !validDate) {
        return null;
    }

    let browseNewAndCustomLink = null;
    if (!isNewAndCustomFiltered) {
        const itemTypeNewCustomFilter = getFilterValueByUrlLabel(
            searchBrowse.filters || [],
            tradeDoublePointsPromo.TARGET_FILTER.NAME,
            tradeDoublePointsPromo.TARGET_FILTER.ATTRIBUTE
        );

        if (itemTypeNewCustomFilter) {
            browseNewAndCustomLink = (
                <React.Fragment>
                    <span className={styles.divider}>|</span>
                    <a
                        href={itemTypeNewCustomFilter.link}
                        onClick={e => {
                            e.preventDefault();
                            onLinkClick();
                        }}
                    >
                        <FormattedMessage
                            id="SbRespTradePromoDoublePoints.newAndCustomLink"
                            defaultMessage="Browse New & Custom Lighting"
                        />
                    </a>
                </React.Fragment>
            );
        }
    }

    return (
        <div className={styles.wrapper}>
            <span className={styles.circle}>
                <span className={styles.circleDouble}>{doubleCopyEl}</span>
                <span className={styles.circlePoints}>
                    <FormattedMessage
                        id="SbRespTradePromoDoublePoints.points"
                        defaultMessage="points"
                    />
                </span>
            </span>

            <span className={styles.copy}>
                <FormattedMessage id="SbRespTradePromoDoublePoints.earn" defaultMessage="Earn" />{' '}
                <b className={styles.double}>{doubleCopyEl}</b>{' '}
                <FormattedMessage
                    id="SbRespTradePromoDoublePoints.lightingPurchases"
                    defaultMessage="points on New & Custom lighting purchases until 10/31"
                />
            </span>

            {browseNewAndCustomLink}
        </div>
    );
}

SbRespTradePromoDoublePointsComponent.propTypes = {
    searchBrowse: PropTypes.object.isRequired,
    onLinkClick: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
    return {
        onLinkClick() {
            dispatch(
                addAndApplyFilter(tradeDoublePointsPromo.TARGET_FILTER.NAME, {
                    urlLabel: tradeDoublePointsPromo.TARGET_FILTER.ATTRIBUTE,
                })
            );
        },
    };
}

export const SbRespTradePromoDoublePoints = createFragmentContainer(
    connect(
        null,
        mapDispatchToProps
    )(SbRespTradePromoDoublePointsComponent),
    {
        searchBrowse: graphql`
            fragment SbRespTradePromoDoublePoints_searchBrowse on SearchBrowseQueryConnection {
                appliedFilters @include(if: $isTrade) {
                    name
                    values {
                        urlLabel
                    }
                }
                filters @include(if: $isTrade) {
                    name
                    values(limit: 15) {
                        link
                        urlLabel
                    }
                }
            }
        `,
    }
);
